import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

export interface MeetingLinkUrlResponse {
  shortUrl: string;
  previewLine: string;
}

@Injectable({ providedIn: 'root' })
export class ShortLinksService {
  private API_URL = '/api/short-links/';

  headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private httpClient: HttpClient) { }


  // Fetches the composed meeting link preview for a user. Returns null when the user has no bookingUsername.
  getMeetingLinkUrlForUser(userId: string): Observable<MeetingLinkUrlResponse | null> {
    return this.httpClient.get<MeetingLinkUrlResponse | null>(this.API_URL + 'meeting-link-url/' + userId);
  }

}
